export default {
    SIMPLE: 'simple',
    CONFIGURABLE: 'configurable',
    BUNDLE: 'bundle',
    VIRTUAL: 'virtual',
    GROUPED: 'grouped',
    GIFT_CARD: 'giftvoucher',
}



// WEBPACK FOOTER //
// ./src/view/constant/ProductTypeConstant.js